<template>
  <div
    class="o-flex -alignCenter t-caption1 t-fontWeightMedium"
    :class="{
      'u-colorDarkMediumEmphasis': !liked,
      'u-colorLove': liked,
    }"
    tabindex="0"
    data-cy="LikeCount">
    <SvgIcon
      :type="iconType"
      data-cy="LikeCount__icon"
      :large="!medium"
      :medium="medium" />
    <span class="u-marginLeft1">
      {{ count }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    count: {
      required: true,
      type: Number,
    },
    liked: {
      default: false,
      type: Boolean,
    },
    medium: {
      required: false,
      type: Boolean,
      default: false,
    },
    // outline or filled
    type: {
      required: false,
      type: String,
      default: '',
    },
  },
  computed: {
    iconType() {
      if (this.type) {
        return `like_${this.type}`
      }
      return this.liked ? 'like_filled' : 'like_outline'
    },
  },
}
</script>
